 
    
$(document).ready(function(){

    // console.log('function ready')

    $('li .subtitle').on('click', infoToggle); 
});

function infoToggle() {
	//console.log('infoToggle	'+$(this).text())
	$(this).toggleClass('open');
	$(this).next().slideToggle(400);
}
